import type { BiomeId } from '@/domain/world/types';
import type { ExpeditionRun, RunOutcome } from './types';
import type { PickedMutation } from '@/domain/mutation/types';

export function startRun(input: { id: string; biome: BiomeId; nowMs: number }): ExpeditionRun {
  return {
    id: input.id,
    biome: input.biome,
    startedAtMs: input.nowMs,
    endedAtMs: null,
    outcome: 'in-progress',
    enemiesKilled: 0,
    xpGained: 0,
    pickedMutations: [],
  };
}

export function endRun(run: ExpeditionRun, outcome: Exclude<RunOutcome, 'in-progress'>, nowMs: number): ExpeditionRun {
  return { ...run, outcome, endedAtMs: nowMs };
}

export function addKill(run: ExpeditionRun, xp: number): ExpeditionRun {
  return { ...run, enemiesKilled: run.enemiesKilled + 1, xpGained: run.xpGained + xp };
}

export function addPick(run: ExpeditionRun, pick: PickedMutation): ExpeditionRun {
  return { ...run, pickedMutations: [...run.pickedMutations, pick] };
}

export function shouldOfferPick(killsBefore: number, killsAfter: number, thresholds: ReadonlyArray<number>): boolean {
  for (const t of thresholds) {
    if (killsBefore < t && killsAfter >= t) return true;
  }
  return false;
}

/** Decide outcome dado HP e estado da criatura. */
export function decideOutcomeAtHpZero(input: {
  sick: boolean;
  stage: 'baby' | 'teen' | 'adult' | 'elder';
}): 'fainted' | 'died' {
  if (input.sick || input.stage === 'elder') return 'died';
  return 'fainted';
}
